import {Injectable, OnDestroy} from '@angular/core';

import {Subscription} from 'rxjs';

@Injectable()
export class ManagedComponent implements OnDestroy {
    protected subscriptions: Subscription[];

    constructor() {
        this.subscriptions = [];
    }

    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
